import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "app/store";

export const selectGeozones = (state: RootState) =>
  state.rootReducer.geozonesStore.geozones;

export const selectIsLoadingGeozones = (state: RootState) =>
  state.rootReducer.geozonesStore.isLoadingGeozones;

export const selectSelectedGeozone = (state: RootState) =>
  state.rootReducer.geozonesStore.selectedGeozone;

export const selectIsLoadingSelectedGeozone = (state: RootState) =>
  state.rootReducer.geozonesStore.isLoadingSelectedGeozone;

export const selectGeozoneObjects = (state: RootState) =>
  state.rootReducer.geozonesStore.geozoneObjects;

export const selectIsLoadingGeozoneObjects = (state: RootState) =>
  state.rootReducer.geozonesStore.isLoadingGeozoneObjects;

export const selectGeozoneObjectsMarkers = (state: RootState) =>
  state.rootReducer.geozonesStore.geozoneObjectsMarkers;

export const selectGeozoneAssignedObjects = (state: RootState) =>
  state.rootReducer.geozonesStore.geozoneAssignedObjects;

export const selectIsLoadingGeozoneAssignedObjects = (state: RootState) =>
  state.rootReducer.geozonesStore.isLoadingGeozoneAssignedObjects;

export const selectGeozoneAssignedObjectsMarkers = (state: RootState) =>
  state.rootReducer.geozonesStore.geozoneAssignedObjectsMarkers;

export const selectGeozonesState = createSelector(
  selectGeozones,
  selectIsLoadingGeozones,
  selectSelectedGeozone,
  selectIsLoadingSelectedGeozone,
  selectGeozoneObjects,
  selectIsLoadingGeozoneObjects,
  selectGeozoneObjectsMarkers,
  selectGeozoneAssignedObjects,
  selectIsLoadingGeozoneAssignedObjects,
  selectGeozoneAssignedObjectsMarkers,
  (
    geozones,
    isLoadingGeozones,
    selectedGeozone,
    isLoadingSelectedGeozone,
    geozoneObjects,
    isLoadingGeozoneObjects,
    geozoneObjectsMarkers,
    geozoneAssignedObjects,
    isLoadingGeozoneAssignedObjects,
    geozoneAssignedObjectsMarkers
  ) => ({
    geozones,
    isLoadingGeozones,
    selectedGeozone,
    isLoadingSelectedGeozone,
    geozoneObjects,
    isLoadingGeozoneObjects,
    geozoneObjectsMarkers,
    geozoneAssignedObjects,
    isLoadingGeozoneAssignedObjects,
    geozoneAssignedObjectsMarkers
  })
);
